import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@barfacil/barfacil-ui'
import { LogOut, User } from 'lucide-react'

import { useAuthContext } from '@/contexts/auth-context'
import { useUnauthorizedContext } from '@/contexts/unauthorized-context'

const UserAvatar = () => {
  const { profile } = useAuthContext()

  return (
    <>
      <AvatarImage src="" alt={profile?.nome} />
      <AvatarFallback>
        <User className="text-gray-300" size={24} />
      </AvatarFallback>
    </>
  )
}

function ProfileMenuContent() {
  const { logout, profile } = useAuthContext()
  const { invalidateToken } = useUnauthorizedContext()

  async function handleOnLogout() {
    await invalidateToken()
    logout()
  }

  return (
    <>
      <div className="flex items-center gap-2 p-4">
        <Avatar>
          <UserAvatar />
        </Avatar>

        <div className="line-clamp-1 flex flex-col gap-px font-medium">
          <span className="text-sm">{profile?.nome}</span>
          <span className="text-xs text-gray-300">{profile?.email}</span>
        </div>
      </div>

      <div className="border border-gray-100" />

      <div className="flex flex-col gap-2 py-2">
        <button
          className="flex flex-1 cursor-pointer items-center gap-2 px-4 py-2 text-sm outline-none transition-colors hover:bg-gray-50 hover:text-gray-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
          onClick={handleOnLogout}
        >
          <LogOut size={24} />
          Sair
        </button>
      </div>
    </>
  )
}

function ProfileMenu() {
  const { profile } = useAuthContext()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          className="gap-3 py-6 hover:bg-gray-100/25 max-sm:max-w-52 max-sm:px-2"
          variant="ghost"
        >
          <strong className="truncate">{profile?.nome}</strong>

          <Avatar className="size-9 cursor-pointer">
            <UserAvatar />
          </Avatar>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-[17.5rem] p-0 pb-2"
        align="end"
        side="bottom"
        sideOffset={12}
      >
        <ProfileMenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { ProfileMenu }
